import React from 'react';
import UploadFileButton from './UploadFileButton';

const UploaderField = ({ input, label, showSuccess, type, autoComplete, meta: { asyncValidating, touched, error, valid, invalid, warning } }) => (
<div className={`form-group ${touched && invalid ? 'has-error' : ''} ${touched && valid && showSuccess ? 'has-success' : ''}`}>
    <div className={asyncValidating ? 'async-validating' : ''}>
        <label className="col-sm-8 col-md-8 col-lg-8 control-label">{label}</label>
        <div className="col-sm-4 col-md-4 col-lg-4">
            <UploadFileButton labe={label} name={input.name} onChange={input.onChange}/>
        </div>
        <div className="col-sm-8 col-md-8 col-lg-8">
            {touched && ((error && <span className="help-block">{error}</span>) || (warning && <span className="help-block">{warning}</span>))}
        </div>    
    </div>
</div>
       
    
  
)

export default UploaderField;


/** WEBPACK FOOTER **
 ** ./src/components/UploaderField.js
 **/